module.exports = "<flash-message name=\"invalid\"></flash-message>\n<div ng-include=\"login.template\" class=\"flex-all flex-col\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/client/app/login/login.html
// module id = 47
// module chunks = 0